import React from 'react';
import useDarkMode from 'use-dark-mode';

import { DamageReportForm } from 'src/contracts/damage-report-form/damage-report-form';
import { ThemeLayout } from 'src/theming';

export const DamageReportPage = (): JSX.Element => {
    const darkMode = useDarkMode();
    return (
        <ThemeLayout darkMode={darkMode}>
            <DamageReportForm />
        </ThemeLayout>
    );
};
